import { ComponentType, createElement, ReactElement, ReactNode } from 'react';
import { css } from 'styled-components';

export const absoluteFillCss = css`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export function CssComponent<T>({
  component: Component,
  ...props
}: T & {
  component: ComponentType<T>;
  children?: ReactNode;
}): ReactElement {
  return createElement(Component as any, props as any)!;
}
